import React from 'react';
import IconClinica from './clinica.svg';
import IconPediatria from './pediatrica.svg';
import IconTraumatologia from './traumatologica.svg';
import IconGinecologia from './ginecologica.svg';
import IconObstetricia from './obstetrica.svg';

export const iconMap = {
  30: IconClinica,
  32: IconPediatria,
  33: IconTraumatologia,
  96: IconGinecologia,
  31: IconObstetricia,
  1: IconClinica,
  3: IconPediatria,
  4: IconTraumatologia,
  5: IconGinecologia,
  2: IconObstetricia,
  default: IconClinica
};

